import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from "vue-axios"

Vue.use(VueAxios, axios)
Vue.use(VueRouter)
Vue.config.productionTip = false

import Home from './components/Home.vue'
import Catalog from './components/Catalog.vue'
import Stocks from './components/Stocks.vue'
import Aboutus from './components/Aboutus.vue'
import Contacts from './components/Contacts.vue'
import Error404 from './components/Error404.vue'

const routes = [
  { path: '/', component: Home },
  { path: '/catalog', component: Catalog},
  { path: '/stocks', component: Stocks},
  { path: '/aboutus', component: Aboutus},
  { path: '/contacts', component: Contacts},
  { path: '*', component: Error404},
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
